if (!customElements.get('tjs-product-group')) {
  class TjsProductGroup extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.loadProducts();
    }

    async loadMetafieldProducts(groupValue, collectionUrl, sectionId) {
      if (!collectionUrl || !sectionId) return [];

      const firstUrl = new URL(collectionUrl, window.location.origin);
      firstUrl.searchParams.set('filter.p.m.custom.group', groupValue);
      firstUrl.searchParams.set('section_id', sectionId);

      return this.loadRenderedProducts(firstUrl, groupValue, 'metafield', sectionId);
    }

    async loadTagProducts(groupValue, sectionId, searchUrl) {
      if (!sectionId || !searchUrl) return [];

      const firstUrl = new URL(searchUrl, window.location.origin);
      const escapedTag = groupValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      firstUrl.searchParams.set('q', `tag:"${escapedTag}"`);
      firstUrl.searchParams.set('type', 'product');
      firstUrl.searchParams.set('options[prefix]', 'none');
      firstUrl.searchParams.set('section_id', sectionId);

      return this.loadRenderedProducts(firstUrl, groupValue, 'tag', sectionId);
    }

    async loadRenderedProducts(firstUrl, groupValue, mode, sectionId) {
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      const matches = [];
      const seenProducts = new Set();
      const visitedPages = new Set();
      let nextUrl = firstUrl;

      while (nextUrl && !visitedPages.has(nextUrl.href)) {
        if (previewThemeId) nextUrl.searchParams.set('preview_theme_id', previewThemeId);
        visitedPages.add(nextUrl.href);

        const response = await fetch(nextUrl.href, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Product Group request failed: ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const resultRoot = documentFragment.querySelector('[data-product-group-response]');
        if (!resultRoot) break;

        resultRoot.querySelectorAll('[data-product-id]').forEach((item) => {
          const productId = item.dataset.productId;
          const source = mode === 'metafield' ? item.dataset.productGroups : item.dataset.productTags;
          let values = [];

          try {
            const parsed = JSON.parse(source || '[]');
            values = Array.isArray(parsed) ? parsed : [];
          } catch (_error) {}

          if (values.includes(groupValue) && !seenProducts.has(productId)) {
            seenProducts.add(productId);
            item.removeAttribute('data-product-tags');
            item.removeAttribute('data-product-groups');
            matches.push(item);
          }
        });

        const nextPath = resultRoot.dataset.nextUrl;
        nextUrl = nextPath ? new URL(nextPath, window.location.origin) : null;

        if (nextUrl) {
          nextUrl.searchParams.set('section_id', sectionId);
          if (mode === 'metafield') {
            nextUrl.searchParams.set('filter.p.m.custom.group', groupValue);
          }
        }
      }

      return matches;
    }

    async loadProducts() {
      const groupValue = this.dataset.groupValue;
      if (!groupValue) return;

      try {
        const matches = this.dataset.groupMode === 'metafield'
          ? await this.loadMetafieldProducts(groupValue, this.dataset.collectionUrl, this.dataset.sectionId)
          : await this.loadTagProducts(groupValue, this.dataset.sectionId, this.dataset.searchUrl);

        if (matches.length > 0) {
          this.querySelector('[data-product-group-items]').replaceChildren(...matches);
          this.hidden = false;
        }
      } catch (error) {
        console.warn('Product Group could not be loaded.', error);
      }
    }
  }

  customElements.define('tjs-product-group', TjsProductGroup);
}
